export default __webpack_public_path__ + "4f11a5ffd545869cd64ba9adefecf667.svg";